import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { RxIntuitiveTeethDiagramFacade } from '../../rx-intuitive-teeth-diagram.facade';
import { RxIntuitiveIndicationRulesService } from '../../services/rx-intuitive-indication-rules.service';
import { RxIntuitiveTeethDiagramQuery } from '../../state/rx-intuitive-teeth-diagram-query';
import { RxIntuitiveTeethDiagramStore } from '../../state/rx-intuitive-teeth-diagram-store';
import { RxIntuitiveTeethDiagramContainerComponent } from '../rx-intuitive-teeth-diagram-container/rx-intuitive-teeth-diagram-container.component';
import { RxIntuitiveTeethDiagramBridgeContainerComponent } from '../rx-intuitive-teeth-diagram-bridge-container/rx-intuitive-teeth-diagram-bridge-container.component';
import { RxIntuitiveToothTreatmentMapper } from '../../services/rx-intuitive-tooth-treatment-mapper.service';
import { RxIntuitiveCopyFromBehaviorService } from '../../services/rx-intuitive-copy-from-behavior.service';
import { RxIntuitiveImplantsViewModalService } from '../../components/rx-intuitive-implants-view-modal/rx-intuitive-implants-view-modal.service';
import { map } from 'rxjs';

@Component({
	selector: 'rx-intuitive-teeth-diagram-base-container',
	templateUrl: './rx-intuitive-teeth-diagram-base-container.component.html',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		RxIntuitiveImplantsViewModalService,
		RxIntuitiveTeethDiagramFacade,
		RxIntuitiveIndicationRulesService,
		RxIntuitiveToothTreatmentMapper,
		RxIntuitiveCopyFromBehaviorService
	],
	imports: [CommonModule, RxIntuitiveTeethDiagramContainerComponent, RxIntuitiveTeethDiagramBridgeContainerComponent]
})
export class RxIntuitiveTeethDiagramBaseContainerComponent extends BaseDestroyableComponent implements OnInit {
	constructor(
		private readonly diagramQuery: RxIntuitiveTeethDiagramQuery,
		private readonly facade: RxIntuitiveTeethDiagramFacade
	) {
		super();
	}

	ngOnInit(): void {
		this.facade.fetchRxAndSyncStore$.pipe(takeUntil(this.componentAlive$)).subscribe();
	}

	readonly hasSelectedBridge$ = this.diagramQuery.selectedBridge$.pipe(map(bridge => bridge !== undefined));
}
